export class Users {
  id: string;
  email: string;
  password: string;
  reg_date: string;
  renewal_date: string;
  active: boolean;
  autologin :boolean;
  period: string;
  payment_date: string;
  cost: string;
  imgSize: string;
};




// WEBPACK FOOTER //
// ./src/models/users.ts